import { QUESTION_TYPE } from '../../fetchSurvey/constants/questionTypes';
import type { MatrixRowAnswers } from '../../submitSurvey/types';
import type { LogicContext } from '../types';

function appendCompositeKey(
  keys: Set<string>,
  rowId: string,
  suffix: string | number | null
): void {
  if (suffix === null || suffix === undefined || suffix === '') {
    return;
  }
  keys.add(`${rowId}_${suffix}`);
}

function appendMatrixCellKey(
  keys: Set<string>,
  rowId: string,
  cellValue: string | number | null | undefined
): void {
  if (cellValue === undefined || cellValue === null || cellValue === '') {
    return;
  }
  appendCompositeKey(keys, rowId, cellValue);
}

export function buildMatrixCompositeKeys(
  questionId: string,
  answerMap: MatrixRowAnswers,
  context: LogicContext
): Set<string> {
  const question = context.questionsById.get(questionId);
  const keys = new Set<string>();

  if (question?.type === QUESTION_TYPE.SLIDER_MATRIX) {
    for (const [rowId, rowValue] of Object.entries(answerMap)) {
      if (rowValue === undefined || rowValue === null) continue;
      if (Array.isArray(rowValue)) {
        rowValue.forEach(value => appendCompositeKey(keys, rowId, value));
      } else {
        appendCompositeKey(keys, rowId, rowValue);
      }
    }
    return keys;
  }

  for (const [rowId, rowValue] of Object.entries(answerMap)) {
    if (rowValue === undefined || rowValue === null) continue;

    if (Array.isArray(rowValue)) {
      for (const cellValue of rowValue) {
        appendMatrixCellKey(keys, rowId, cellValue);
      }
      continue;
    }

    appendMatrixCellKey(keys, rowId, rowValue);
  }

  return keys;
}
